export const NAMESPACE = 'rawJob';

export const CLEANUP = `${NAMESPACE}/CLEANUP`;
